const findRateType = (customer_status) => {   // from only for amc 

    switch (customer_status) {
        case 'SSP':
            return 'ssp_rate'

        case 'AMC':
        case 'I/W':
            return 'rate'    // purchase rate

        case 'O/W':
        case 'O/C':
            return 'rate'

        default:
            break;
    }
}

const calculatePercentage = (total = 0, percentage = 100) => {
    if (typeof total === "number" && typeof percentage === 'number') {
        return parseFloat((Number(percentage) / 100) * Number(total).toFixed(2))
    }
    throw Error('Pass the number')
}


export { findRateType, calculatePercentage }